import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { MiscTypes } from '../../types';
import { CardContentFieldsSchema } from '../shared';

export const ExternalContentSchema = SanityDocumentSchema.extend({
  _type: z.literal(MiscTypes.ExternalContent),
  name: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  url: z
    .string()
    .nullish()
    .transform((x) => x ?? ''),
  cardContent: CardContentFieldsSchema,
  sortDate: z.string().nullish()
});

export type ExternalContent = z.infer<typeof ExternalContentSchema>;
